import {
	AnonymousStudentProfileUpdated,
	AnonymousStudentServiceReady,
	IAnonymousStudentService,
} from '@studyportals/anonymous-student-interfaces';
import { ISubscriber } from '@studyportals/student-interfaces';
import { StudentField } from '@studyportals/studentdomain';
import { GlobalStore } from '..';

export class AnonymousStudentPlugin implements ISubscriber<AnonymousStudentServiceReady>, ISubscriber<AnonymousStudentProfileUpdated>
{
	private anonymousStudentService: IAnonymousStudentService | null = null;

	public install(): Promise<void> {
		if (window.EventAggregationService !== undefined) {
			window.EventAggregationService.subscribeTo(AnonymousStudentServiceReady.EventType, this, true);
			window.EventAggregationService.subscribeTo(AnonymousStudentProfileUpdated.EventType, this);
		}

		return Promise.resolve();
	}

	public async notify(e: AnonymousStudentServiceReady | AnonymousStudentProfileUpdated): Promise<void> {
		if (e.eventType === AnonymousStudentServiceReady.EventType) {
			const event = e as AnonymousStudentServiceReady;

			this.anonymousStudentService = event.anonymousStudentService;
		}

		await this.processNationality();
	}

	private async processNationality(): Promise<void> {
		if (this.anonymousStudentService === null) {
			return;
		}

		const studentData = await this.anonymousStudentService.getStudentData([StudentField.NATIONALITY_COUNTRY_ID]);
		const nationalityCountryId = studentData[StudentField.NATIONALITY_COUNTRY_ID]
			? `${studentData[StudentField.NATIONALITY_COUNTRY_ID]}`
			: null;

		await GlobalStore.actions.changeOriginCountry(nationalityCountryId);
	}
}
